module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.advisory && _vm.advisory.body) ? _c('advisory', {
    attrs: {
      "advisory": _vm.advisory
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewing === 'request'),
      expression: "viewing === 'request'"
    }],
    staticClass: "content relative"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.weightSettingsOpen),
      expression: "weightSettingsOpen"
    }],
    class: [_vm.weightSettingsOpen ? 'open' : '', 'clearfix'],
    attrs: {
      "id": "advanced-weight-settings"
    }
  }, [_c('weight-volume-calculator', {
    ref: "wgtVolCalc",
    attrs: {
      "ntg": _vm.quote.netToGross,
      "d": _vm.quote.density,
      "lbs": _vm.quote.wgtNetLbs,
      "can-emit": _vm.isInitialised,
      "quote": _vm.quote
    },
    on: {
      "data-change": _vm.updateNetLbs,
      "weight-close": function($event) {
        _vm.weightSettingsOpen = false
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.weightSettingsOpen ? 'open' : '', 'form-steps-outer']
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.complete.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "backer clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'FROM_LABEL')))]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": _vm.getConst(_vm.locale, 'FROM_LABEL_TOOLTIP'),
      "placeHolder": _vm.getConst(_vm.locale, 'FROM_INPUT_PLACEHOLDER'),
      "initVal": _vm.initialLocations.fromLocation,
      "fnFormatText": _vm.locationFormat,
      "fnSelectValue": _vm.locationFormat,
      "autoFocus": true,
      "styles": {
        ul: {
          top: '42px'
        },
        input: {
          border: '1px solid #c0c0c0 !important',
          boxShadow: 'none'
        }
      }
    },
    on: {
      "changing": function (data) { return _vm.locationSearch = data; },
      "selection-made": _vm.updateFrom
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'TO_LABEL')))]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": _vm.getConst(_vm.locale, 'TO_LABEL_TOOLTIP'),
      "placeHolder": _vm.getConst(_vm.locale, 'TO_INPUT_PLACEHOLDER'),
      "initVal": _vm.initialLocations.toLocation,
      "fnFormatText": _vm.locationFormat,
      "fnSelectValue": _vm.locationFormat,
      "styles": {
        ul: {
          top: '42px'
        },
        input: {
          border: '1px solid #c0c0c0 !important',
          boxShadow: 'none'
        }
      }
    },
    on: {
      "changing": function (data) { return _vm.locationSearch = data; },
      "selection-made": _vm.updateTo
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "weight"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'WEIGHT_LABEL')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.wgtNetLbs),
      expression: "quote.wgtNetLbs"
    }],
    staticClass: "form-control",
    staticStyle: {
      "border": "1px solid #c0c0c0 !important",
      "boxShadow": "none"
    },
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.getConst(_vm.locale, 'WEIGHT_LABEL_TOOLTIP'),
      "placeholder": _vm.getConst(_vm.locale, 'WEIGHT_INPUT_PLACEHOLDER'),
      "type": "number",
      "id": "weight"
    },
    domProps: {
      "value": (_vm.quote.wgtNetLbs)
    },
    on: {
      "change": _vm.recalculateWeightsAndVolume,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "wgtNetLbs", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Click to enter in different units"
    },
    on: {
      "click": function($event) {
        _vm.weightSettingsOpen = !_vm.weightSettingsOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-balance-scale"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-1"
  }, [_c('button', {
    class: [!_vm.isValid || _vm.reloadingJobTypes ? 'disabled' : '', 'btn mt-25 sq primary p-10'],
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValid || _vm.reloadingJobTypes
    }
  }, [_vm._v("Go")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "badge-container"
  }, _vm._l((_vm.badges), function(badge) {
    return _c('quote-badge', {
      key: badge.domId,
      attrs: {
        "badge": badge
      },
      on: {
        "clicked": function($event) {
          return _vm.show(badge.domId)
        }
      }
    })
  }), 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "advanced-settings-outer"
    }
  }, [_c('section', {
    staticClass: "adv-tabs"
  }, [_c('div', {
    class: [_vm.tab === 'ship' ? 'active' : '', 'tab'],
    on: {
      "click": function($event) {
        _vm.tab = 'ship'
      }
    }
  }, [_vm._v("\n          Shipment\n        ")]), _vm._v(" "), _c('div', {
    class: [_vm.tab === 'customer' ? 'active' : '', 'tab'],
    on: {
      "click": function($event) {
        _vm.tab = 'customer'
      }
    }
  }, [_vm._v("\n          Customer\n        ")]), _vm._v(" "), _c('div', {
    class: [!_vm.isValid ? 'disabled' : '', _vm.tab === 'pref' ? 'active' : '', 'tab'],
    on: {
      "click": function($event) {
        return _vm.updateTab('pref')
      }
    }
  }, [_vm._v("\n          Preferences\n        ")]), _vm._v(" "), (_vm.rateFillerEnabled) ? _c('div', {
    class: [_vm.tab === 'filler' ? 'active' : '', 'tab'],
    on: {
      "click": function($event) {
        _vm.tab = 'filler'
      }
    }
  }, [_vm._v("\n          Rate Filler\n        ")]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "adv-tabs-content"
  }, [(_vm.tab === 'ship') ? _c('div', {
    staticClass: "[tab === 'ship' ? 'active' : '', 'tab-content' ]"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "direction"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'DIRECTION_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.direction),
      expression: "quote.direction"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "direction"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.getSystemOptions('DIRECTION')), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": option.id === _vm.quote.direction.id
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'TRANSPORT_TYPE_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.transportType),
      expression: "quote.transportType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "transportType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "transportType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.getSystemOptions('TRANSPORT_TYPE')), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": option.id === _vm.quote.transportType.id
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "mode"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'MODE_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.mode),
      expression: "quote.mode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.getSystemOptions('MODE')), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": option.id === _vm.quote.mode.id
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "service"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'SERVICE_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.service),
      expression: "quote.service"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "service"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "service", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.getSystemOptions('SERVICE_PROVIDED')), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": option.id === _vm.quote.service.id
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "category"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'CATEGORY_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.category),
      expression: "quote.category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.getSystemOptions('SHIPMENT_CATEGORY')), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": option.id === _vm.quote.category.id
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]), _vm._v(" "), (_vm.isMultipleBrandsEnabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "brand"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'SLICE_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.brand),
      expression: "quote.brand"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "brand"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.userBrandGroups), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": _vm.quote.brand && option.brands === _vm.quote.brand
      }
    }, [_vm._v("\n                    " + _vm._s(option.name) + "\n                  ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDistance),
      expression: "showDistance"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "distance"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'DISTANCE_LABEL')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.distance),
      expression: "quote.distance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "distance"
    },
    domProps: {
      "value": (_vm.quote.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "distance", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDistance),
      expression: "showDistance"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "distanceType"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'DISTANCE_TYPE_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.distanceType),
      expression: "quote.distanceType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "distanceType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "distanceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('DISTANCE_TYPE')), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": _vm.quote.distanceType && option.id === _vm.quote.distanceType.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.name) + "\n                  ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "goodsType"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'GOODS_TYPE_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.goodsType),
      expression: "quote.goodsType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "goodsType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "goodsType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.getSystemOptions('GOODS_TYPE')), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": option.id === _vm.quote.goodsType.id
      }
    }, [_vm._v(_vm._s(option.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "containerType"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'CONTAINER_TYPE_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.containerType),
      expression: "quote.containerType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "containerType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "containerType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('CONTAINER_TYPE')), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": option.id === _vm.quote.containerType.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "woodLoose"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'WOOD_LOOSE_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.woodLoose),
      expression: "quote.woodLoose"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "woodLoose"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "woodLoose", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('WOOD_LOOSE')), function(option) {
    return _c('option', {
      domProps: {
        "value": option,
        "selected": _vm.quote.woodLoose && option.id === _vm.quote.woodLoose.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "jobType"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'JOB_TYPE_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.jobType),
      expression: "quote.jobType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "jobType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "jobType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.availableJobTypes), function(jobtype, i) {
    return _c('option', {
      domProps: {
        "value": jobtype,
        "selected": _vm.quote.jobType.id === jobtype.id
      }
    }, [_vm._v(_vm._s(jobtype.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "pickUpDate"
    }
  }, [_vm._v("Pick Up Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.pickUpDate),
      expression: "quote.pickUpDate"
    }],
    staticClass: "mai-date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.quote.pickUpDate)
    },
    on: {
      "blur": _vm.validatePickUpDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "pickUpDate", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.tab === 'customer') ? _c('div', {
    class: [_vm.tab === 'customer' ? 'active' : '', 'tab-content']
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "cust-fn"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'FIRSTNAME_LABEL')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.firstName),
      expression: "quote.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cust-fn"
    },
    domProps: {
      "value": (_vm.quote.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "cust-ln"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'LASTNAME_LABEL')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.lastName),
      expression: "quote.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cust-ln"
    },
    domProps: {
      "value": (_vm.quote.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "lastName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "reference-number"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'EXTERNAL_REFERENCE')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invalidReferenceNumber),
      expression: "invalidReferenceNumber"
    }],
    staticClass: "validation-error"
  }, [_vm._v("Invalid Reference Number")]), _vm._v(" "), (_vm.isCrownRefFormatEnabled) ? _c('div', {
    staticClass: "flex-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceNumber.text1),
      expression: "referenceNumber.text1"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.referenceNumber.text1)
    },
    on: {
      "blur": _vm.validateReferenceText1,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.referenceNumber, "text1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceNumber.text2),
      expression: "referenceNumber.text2"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.referenceNumber.text2)
    },
    on: {
      "blur": _vm.validateReferenceText2,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.referenceNumber, "text2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceNumber.text3),
      expression: "referenceNumber.text3"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.referenceNumber.text3)
    },
    on: {
      "blur": _vm.validateReferenceText3,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.referenceNumber, "text3", $event.target.value)
      }
    }
  })]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.reference),
      expression: "quote.reference"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "reference-number"
    },
    domProps: {
      "value": (_vm.quote.reference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "reference", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'ACCOUNT_LABEL')))]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.partySearchResults,
      "title": _vm.getConst(_vm.locale, 'ACCOUNT_TOOLTIP_LABEL'),
      "placeHolder": _vm.getConst(_vm.locale, 'ACCOUNT_PLACEHOLDER'),
      "groupAddons": _vm.addOnAccount({
        type: 'Account'
      }),
      "initVal": _vm.initialParties.account,
      "fnFormatText": _vm.displayParty,
      "fnSelectValue": _vm.displayParty
    },
    on: {
      "changing": _vm.updatePartySearchAcc,
      "selection-made": _vm.updateAccount
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'BOOKER_LABEL')))]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.partySearchResults,
      "title": _vm.getConst(_vm.locale, 'BOOKER_TOOLTIP_LABEL'),
      "placeHolder": _vm.getConst(_vm.locale, 'BOOKER_PLACEHOLDER'),
      "groupAddons": _vm.addOnBooker({
        type: 'Booker'
      }),
      "initVal": _vm.initialParties.booker,
      "fnFormatText": _vm.displayParty,
      "fnSelectValue": _vm.displayParty
    },
    on: {
      "changing": _vm.updatePartySearchBook,
      "selection-made": _vm.updateBooker
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "currency"
    }
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'CURRENCY_LABEL')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.currency),
      expression: "quote.currency"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.quote, "currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.currencies), function(cur, i) {
    return _c('option', {
      domProps: {
        "value": cur,
        "selected": _vm.quote.currency && cur.id === _vm.quote.currency.id
      }
    }, [_vm._v(_vm._s(cur.name))])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.tab === 'filler') ? _c('rate-filler', {
    attrs: {
      "routes": _vm.rateFillerAvailableRoutes,
      "services": _vm.rateFillerAvailableRates,
      "rate-request": _vm.rateRequest
    },
    on: {
      "add-service": function (service) { return _vm.rateFillerAvailableRates.push(service); },
      "rate-filled": function (prefs) { return _vm.optimiseFromPrefs(prefs); }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.tab === 'pref' ? 'active' : '', 'tab-content']
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('prefs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 'pref' && _vm.isValid),
      expression: "tab === 'pref' && isValid"
    }],
    attrs: {
      "jobTypeId": _vm.quote.jobType.id,
      "displayParty": _vm.displayParty
    }
  }), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 'pref' && !_vm.isValid),
      expression: "tab === 'pref' && !isValid"
    }]
  }, [_vm._v("\n              Ensure your chosen quote is valid before adding preferences\n            ")])], 1)])], 1)])]), _vm._v(" "), ((_vm.viewing === 'response' && _vm.response !== null) && _vm.jobLoaded) ? _c('quote-rates', {
    attrs: {
      "response": _vm.response,
      "request": _vm.reqDetails,
      "graphData": _vm.graphData,
      "fullRequest": _vm.rateRequest,
      "chargeProfile": _vm.chargeProfile,
      "job": _vm.job,
      "pref-with-notes": _vm.prefWithNotes
    },
    on: {
      "close-rates": function($event) {
        _vm.viewing = 'request'
      },
      "job-saved": _vm.goToJobPage,
      "choice-made": _vm.updateOption,
      "quoteDetailsUpdate": _vm.updateQuote
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b0b1c02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteForm.vue
// module id = 2085
// module chunks = 1